import React, { useState } from 'react';

/**
 * Zeigt einen Wert mit Kopier-Button; Passwoerter werden maskiert und lassen
 * sich per Auge-Button einblenden. Kopieren gibt eine kurze Rueckmeldung.
 */
export default function KopierWert({ label, wert, geheim = false }) {
  const [sichtbar, setSichtbar] = useState(false);
  const [kopiert, setKopiert] = useState(false);

  if (!wert) return null;

  const kopieren = async () => {
    await navigator.clipboard.writeText(wert);
    setKopiert(true);
    setTimeout(() => setKopiert(false), 1500);
  };

  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="w-20 shrink-0 text-xs uppercase tracking-wide text-ink-muted">{label}</span>
      <span className="min-w-0 flex-1 truncate font-mono text-ink">
        {geheim && !sichtbar ? '••••••••••••' : wert}
      </span>
      {geheim && (
        <button
          type="button"
          onClick={() => setSichtbar(!sichtbar)}
          title={sichtbar ? 'Verbergen' : 'Anzeigen'}
          className="shrink-0 text-ink-muted transition-colors hover:text-ink"
        >
          {sichtbar ? '🙈' : '👁️'}
        </button>
      )}
      <button
        type="button"
        onClick={kopieren}
        title="In die Zwischenablage kopieren"
        className="shrink-0 text-ink-muted transition-colors hover:text-ink"
      >
        {kopiert ? '✅' : '📋'}
      </button>
    </div>
  );
}
